import {AfterViewInit, Component, OnInit} from "@angular/core";
import {ScriptLoaderService} from "../services/script-loader.service";

@Component({
  selector: 'app-follow',
  templateUrl: './follow.component.html'
})
export class FollowComponent implements OnInit, AfterViewInit {

  constructor(private _script: ScriptLoaderService) {
  }

  ngOnInit() {
  }

  ngAfterViewInit() {
    this._script.load('#cr__init-7b0cae88',
        'https://embed.crowdriff.com/js/init?hash=7b0cae88');
  }

}



// WEBPACK FOOTER //
// /var/www/subdomains/codebnb/hanoigo/public_html/client_user/src/app/follow/follow.component.ts